import { Injectable, OnDestroy } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { EMPTY_USER_PROFILE, UserProfile } from './user.datamodel';
import { userInitialState } from './user.reducer';

import * as UserSelectors from './user.selectors';

@Injectable()
export class UserService implements OnDestroy {
  private user: UserProfile = userInitialState.user;
  private readonly subscriptions = new Subscription();

  constructor(
    private readonly store: Store,
  ) {
    this.subscriptions.add(
      this.store.pipe(select(UserSelectors.user)).subscribe(user => this.user = user ?? EMPTY_USER_PROFILE)
    );
  }

  /**
   * Get the user profile
   */
  getUser(): UserProfile {
    return this.user;
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
